import React from 'react';
import _concat from "lodash/concat";
import _get from 'lodash/get';
import styles from './datatable.module.scss';
import { Checkbox, KoDateFormatter,  KoRating,  KoText } from '../index';
import KoIcon from '@kwapio/icons';
import User from './widgets/user';
import Status from './widgets/status';
import Groups from './widgets/groups';
import Description from './widgets/description';
import Comments from './widgets/comments';
import Priority from './widgets/priority';
import Members from './widgets/members';
import Methods from './widgets/methods';
import API from './widgets/api';
import Phone from './widgets/phone';
import ExecutionTime from './widgets/time';
import SalaryRange from './widgets/salaryRange';
import Departments from './widgets/departments';
import Assignees from './widgets/assignees';
import TaskStatus from './widgets/taskStatus';
import SprintStatus from './widgets/sprintStatus';
import TicketLink from './widgets/ticketLink';
import InvoiceLink from './widgets/invoiceLink';
import FileLink from './widgets/fileLink';
import PullRequestLink from './widgets/prLink';
import ReleaseStatus from './widgets/releaseStatus';
import Link from './widgets/link';
import Attachments from './widgets/attachments';
import KoRichTextEditorReadOnly from '../richText/richTextView';
import UserStatus from './widgets/userStatus';
import Percentage from './widgets/percentage';
import PercentageCircle from './widgets/percentagecircle';
import DashBoardLink from './widgets/dashboardlink';
import Text from './widgets/text';
import UserRole from './widgets/userRole';
import OptionalStatus from './widgets/optionalstatus';
import MultiTicketLink from './widgets/multiticketLink';
import EventSlot from './widgets/eventSlot';
import Folder from './widgets/folder';
import OverDueStatus from './widgets/overdueStatus';
import Log from './widgets/log';
import Workspace from './widgets/workspace';
import WorkFlowStatus from './widgets/workflowStatus';
import MultiTicketLinkStatic from './widgets/multiticketLinkstatic';
import KoStaicMembers from '../staticMember';
import FileInfo from './widgets/fileObject';
import CaseStatus from './widgets/caseStatus';
import DocumentLink from './widgets/docLink';
import SharedWithUsers from './widgets/sharedUsers';
import SharedWithGroups from './widgets/sharedgroups';
import HrefLink from './widgets/href';
import InvoiceStatus from './widgets/invoicestatus';
import KoMediaText from './widgets/mediaText';
import Stock from './widgets/stock';
import CustomerStatus from './widgets/customerStatus';
import { calculateOverallRatings } from 'shared/utils';
import PaymnetStatus from './widgets/paymnetStatus';
import Subscriptions from './widgets/subscription';
import Aamount from './widgets/amount';
import MobileEmail from './widgets/emailMobile';
import CaseTypeStatus from './widgets/casetype';

const serializeColumns = (columns, onCellClick, onExtraClick, refreshData, isEpic) => {
  columns.map(function(column) {
    column.dataIndex = column.id;
    column.key = column.id;
    column.ellipsis = true;
    column.customKey= column?.dataKey;
    column.sorter = false;
    column.width = column?.width || 200;
    column.filterIcon = <KoIcon name='FilterOutlined'/>;
    column.filtered=true;
    column.render = (data, row, dataIndex, key ) => {
      let dataType = <KoText  className={styles.text} style={{maxWidth: column?.width || 200}} text={data} ellipsis={true}/>;
      if (column['widget'] === 'object') {
        dataType = <KoText className={styles.text} text={_get(row, column.customKey)} ellipsis={true}/>;
      }else if (column['widget'] === 'address') {
        const addressParts = [
          data?.addressLine1,
          data?.addressLine2,
          data?.city,
          data?.state,
          data?.country,
          data?.pincode ? String(data.pincode) : null
        ].filter(Boolean);
        const formattedAddress = addressParts.join(", ");
        dataType = <KoText className={styles.text} text={formattedAddress} ellipsis={true}/>;
      }else if (column['widget'] === 'name') {
        dataType = <KoText className={styles.text} text={_get(row, 'firstName') + ' ' + _get(row, 'lastName')} ellipsis={true}/>;
      }else if (column['widget'] === 'mediaText') {
        dataType = <KoMediaText className={styles.text} data={data} onExtraClick={onExtraClick && onExtraClick} refreshData={refreshData && refreshData} row={row} ellipsis={true}/>;
      }else if (column['widget'] === 'stock') {
        dataType = <Stock className={styles.text} data={data} refreshData={refreshData && refreshData} ellipsis={true}/>;
      }else if (column['widget'] === 'billable') {
        dataType = <KoText className={styles.text} text={row?.isBillable ? data : '00h 00m'} ellipsis={true}/>;
      }else if (column['widget'] === 'nonbillable') {
        dataType = <KoText className={styles.text} text={!row?.isBillable ? data : '00h 00m'} ellipsis={true}/>;
      } else if (column['widget'] === 'profile') {
        dataType = <User onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'percent') {
        dataType = <Percentage onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'percentCircle') {
        dataType = <PercentageCircle onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'assignees') {
        dataType = <Assignees onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} column={column} />;
      }else if (column['widget'] === 'taskstatus') {
        dataType = <TaskStatus isEpic={isEpic} isLog={column?.isLog ? column?.isLog : false}  onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'customerstatus') {
        dataType = <CustomerStatus column={column} isLog={column?.isLog ? column?.isLog : false}  onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'casestatus') {
        dataType = <CaseStatus  isLog={column?.isLog ? column?.isLog : false}  onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'taskstatuscob') {
        dataType = <TaskStatus  cob={true} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'workflowstatus') {
        dataType = <WorkFlowStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'sprintstatus') {
        dataType = <SprintStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'releasestatus') {
        dataType = <ReleaseStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'phone') {
        dataType = <Phone onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'dateTime') {
        dataType = <KoDateFormatter onCellClick={onCellClick && onCellClick} className={styles.text} format={column?.format} timeZone={column?.timeZone} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'date') {
        dataType = <KoDateFormatter onCellClick={onCellClick && onCellClick} className={styles.text} format={column?.format} timeZone={column?.timeZone} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'userStatus') {
        dataType = <UserStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'userRole') {
        dataType = <UserRole onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }
      else if (column['widget'] === 'caseType') {
        dataType = <CaseTypeStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'status') {
        dataType = <Status onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'invoicestatus') {
        dataType = <InvoiceStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }  else if (column['widget'] === 'bool') {
        dataType = <Status bool={true} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'groups') {
        dataType = <Groups onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'description') {
        dataType = <Description onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} dataIndex={dataIndex} />;
      } else if (column['widget'] === 'comments') {
        dataType = <Comments onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'priority') {
        dataType = <Priority isEpic={isEpic} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'members') {
        dataType = <Members onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'staticmember') {
        dataType = <KoStaicMembers onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'file') {
        dataType = <FileInfo onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} colName={column?.name} onExtraClick={onExtraClick && onExtraClick} />;
      } else if(column['widget'] === 'sharedWithUsers') {
        dataType = <SharedWithUsers onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'sharedWithGroups') {
        dataType = <SharedWithGroups onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'checkbox') {
        dataType = <Checkbox  row={row} onCellClick={onCellClick && onCellClick} value={data} />;
      } else if (column['widget'] === 'methods') {
        dataType = <Methods  row={row} onCellClick={onCellClick && onCellClick} value={data} />;
      } else if (column['widget'] === 'api') {
        dataType = <API  row={row} onCellClick={onCellClick && onCellClick} value={data} />;
      } else if (column['widget'] === 'time') {
        dataType = <ExecutionTime   row={row} onCellClick={onCellClick && onCellClick} value={data} />;
      } else if (column['widget'] === 'salaryRange') {
        dataType = <SalaryRange   row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'department') {
        dataType = <Departments  row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'ticketLink') {
        dataType = <TicketLink row={row} colName={column?.name} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} onExtraClick={onExtraClick && onExtraClick}/>;
      }else if (column['widget'] === 'docLink') {
        dataType = <DocumentLink row={row} colName={column?.name} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} onExtraClick={onExtraClick && onExtraClick}/>;
      } else if (column['widget'] === 'multiTicketLinkStatic') {
        dataType = <MultiTicketLinkStatic row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      }else if (column['widget'] === 'multiTicketLink') {
        dataType = <MultiTicketLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'link') {
        dataType = <Link row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'dashboardLink') {
        dataType = <DashBoardLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'invoiceLink') {
        dataType = <InvoiceLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'fileLink') {
        dataType = <FileLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'pullRequestLink') {
        dataType = <PullRequestLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if (column['widget'] === 'href') {
        dataType = <HrefLink row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      }else if (column['widget'] === 'richText') {
        dataType = <KoRichTextEditorReadOnly row={row} onCellClick={onCellClick && onCellClick} initialValues={data} />;
      } else if(column['widget'] === 'attachments'){
        dataType = <Attachments row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if(column['widget'] === 'text'){
        dataType = <Text row={row} width={column?.width}  onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if(column['widget'] === 'optionalStatus'){
        dataType = <OptionalStatus row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      } else if(column['widget'] === 'eventSlot'){
        dataType = <EventSlot row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      }else if(column['widget'] === 'folder'){
        dataType = <Folder row={row} onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} />;
      }else if (column['widget'] === 'overDueStatus') {
        dataType = <OverDueStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'log') {
        dataType = <Log onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if (column['widget'] === 'workspace') {
        dataType = <Workspace onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'ratings'){
        dataType = <KoRating disabled onCellClick={onCellClick && onCellClick} value={calculateOverallRatings(row?.ratings)} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'paymentStatus'){
        dataType = <PaymnetStatus onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'subscription'){
        dataType = <Subscriptions onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'amount'){
        dataType = <Aamount disabled onCellClick={onCellClick && onCellClick} data={data} refreshData={refreshData && refreshData} row={row} />;
      }else if(column['widget'] === 'mobileEmail'){
        dataType = <MobileEmail onCellClick={onCellClick && onCellClick} data={{
          mobile: row?.mobile,
          email: row?.createdBy,
          firstName: row?.name || row?.createdBy.split('@')[0]
        }} refreshData={refreshData && refreshData} row={row} />;
      } else if (column['widget'] === 'custom' && typeof column.customRender === 'function') {
        dataType = column.customRender(data, row);
      }


      return dataType;
    };
    return column;
  });
  return columns;
};

function addRightColumns(allcolumns, columnList) {
  columnList = columnList.map(function(colObject) {
    return colObject;
  });
  return _concat(allcolumns, columnList);
}
function addLeftColumns(allcolumns, columnList) {
  columnList = columnList.map(function(colObject) {
    return colObject;
  });
  return _concat(columnList, allcolumns);
}

export {
  serializeColumns,
  addRightColumns,
  addLeftColumns
};
